import { Address, BookingReasons, CompanyLead, CustomerType, GiftCard, Product } from "@raskrask-dk/raskrask-utils";
import {
  SetCustomerEmail,
  SetCustomerName,
  SetCustomerPhone,
  AcceptConditions,
  SetSpecialNeeds,
  SetProblemDescription,
  Next,
  SetKlippeCard,
  SetPromoCode,
  SetBookingReasons,
  SetParkingText,
  SetCompanyAdminName,
  SetCompanyName,
} from "./actions";
import {SetGiftCard} from "./actions/setGiftCard.action";

export type DetailsStateActions =
  | SetPromoCode
  | SetKlippeCard
  | SetCustomerEmail
  | SetCustomerName
  | SetCustomerPhone
  | AcceptConditions
  | SetSpecialNeeds
  | SetProblemDescription
  | Next
  | SetBookingReasons
  | SetParkingText
  | SetCompanyAdminName
  | SetCompanyName
  | SetGiftCard;

export const detailsActions = [
  SetCustomerEmail,
  SetCustomerName,
  SetCustomerPhone,
  AcceptConditions,
  SetSpecialNeeds,
  SetProblemDescription,
  SetKlippeCard,
  Next,
  SetPromoCode,
  SetBookingReasons,
  SetParkingText,
  SetCompanyAdminName,
  SetCompanyName,
  SetGiftCard,
] as const;

export type detActions = (typeof detailsActions)[number];

export interface IGetData {
  address: Address | undefined;
  product: Product | CompanyLead;
  specialNeeds: boolean | undefined;
  problemDescription: string | undefined;
  acceptConditions: boolean | undefined;
  customerName: string | undefined;
  customerPhone: number | undefined;
  customerEmail: string | undefined;
  promoCode: string | undefined;
  klippeCardCode: string | undefined;
  bookingReasons: BookingReasons | undefined;
  parkingText: string | undefined;
  companyAdminName: string | undefined;
  companyName: string | undefined;
  giftCard: GiftCard | undefined;
}

export interface DetailsStateDependencies {
  product: Product | CompanyLead;
  address: Address;
  customerType: CustomerType;
  klippeCardCode?: string | undefined;
  customerName?: string | undefined;
  customerPhone?: number | undefined;
  customerEmail?: string | undefined;
  companyAdminName?: string | undefined;
  companyName?: string | undefined;
}
